module.exports = "#version 300 es\r\nprecision highp float;\r\n\r\nin vec4 fs_Col;\r\nin vec4 fs_Pos;\r\n\r\nout vec4 out_Col;\r\n\r\nvoid main()\r\n{\r\n    out_Col = fs_Col;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/shaders/instanced-mat-frag.glsl
// module id = 76
// module chunks = 0